<template>
    <span @click="resultByKeyword()"> {{ keyword }}</span>
</template>

<script>
export default {
    name: 'Keyword',
    props: {
        keyword: String,        
    },
    methods: {
        resultByKeyword() {
            //console.log("searched by params in Keyword.vue:resultByKeyword after click on keyword")
            this.$router.push({ name: 'keywordSearch', params: {keyword: this.keyword } })
        }
    },
}
</script>

<style lang="scss" scoped>
</style>